import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCartStore, useAuthStore } from '../context/store';
import toast from 'react-hot-toast';

const C = { prune:'#4A1942',pruneL:'#6B2E62',pruneD:'#2D0F28',or:'#C9A84C',creme:'#FDF6EC',cremeD:'#F5E8D3',cremeMid:'#EDD9BB',noir:'#1A0F18',gris:'#5C4A58',grisM:'#8B7A86',grisL:'#C4B8C0',vert:'#27AE60',rouge:'#C0392B' };

export default function Cart() {
  const { items, updateQty, removeItem, subtotal, total, remise, codePromo, applyPromo, count } = useCartStore();
  const { isAuthenticated } = useAuthStore();
  const navigate = useNavigate();
  const [promoInput, setPromoInput] = useState('');
  const [loadingPromo, setLoadingPromo] = useState(false);

  const handlePromo = async () => {
    if (!promoInput.trim()) return;
    setLoadingPromo(true);
    try {
      await applyPromo(promoInput.trim().toUpperCase());
      toast.success('Code promo appliqué !');
    } catch { toast.error('Code invalide ou expiré'); }
    finally { setLoadingPromo(false); }
  };

  const handleCheckout = () => {
    if (!isAuthenticated) { navigate('/connexion?redirect=/checkout'); return; }
    navigate('/checkout');
  };

  if (items.length === 0) return (
    <div style={{ minHeight: '100vh', background: C.creme, paddingTop: 72, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: '80px 24px' }}>
      <span style={{ fontSize: 80 }}>🛍</span>
      <h1 style={{ fontFamily: 'Georgia, serif', fontWeight: 300, fontSize: 36, color: C.pruneD, margin: '24px 0 12px' }}>Votre panier est vide</h1>
      <p style={{ color: C.grisM, fontSize: 16, marginBottom: 36 }}>Découvrez notre belle collection de mode africaine</p>
      <Link to="/boutique" style={{ padding: '14px 36px', background: `linear-gradient(135deg, ${C.prune}, ${C.pruneL})`, color: C.or, borderRadius: 10, textDecoration: 'none', fontSize: 15, fontWeight: 700, boxShadow: `0 4px 20px rgba(74,25,66,.3)` }}>
        Explorer la boutique →
      </Link>
    </div>
  );

  return (
    <div style={{ minHeight: '100vh', background: C.creme, paddingTop: 72 }}>
      <div style={{ maxWidth: 1100, margin: '0 auto', padding: '40px 24px' }}>
        <h1 style={{ fontFamily: 'Georgia, serif', fontWeight: 300, fontSize: 36, color: C.pruneD, marginBottom: 32 }}>
          Mon panier <span style={{ fontSize: 18, color: C.grisM, fontFamily: 'monospace' }}>({count()} article{count() > 1 ? 's' : ''})</span>
        </h1>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 360px', gap: 24, alignItems: 'start' }}>
          {/* Articles */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {items.map(item => {
              const prix = item.product.prix_promo || item.product.prix;
              const img = item.product.images?.[0];
              return (
                <div key={item.key} style={{ background: 'white', borderRadius: 16, padding: 20, border: `1px solid ${C.cremeMid}`, display: 'flex', gap: 16, alignItems: 'center' }}>
                  {/* Image */}
                  <div style={{ width: 100, height: 120, borderRadius: 10, overflow: 'hidden', background: `linear-gradient(135deg, ${C.cremeD}, ${C.cremeMid})`, flexShrink: 0 }}>
                    {img ? <img src={img} alt={item.product.nom} style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 36 }}>🌺</div>}
                  </div>
                  {/* Infos */}
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <span style={{ fontSize: 10, fontFamily: 'monospace', textTransform: 'uppercase', letterSpacing: '.1em', color: C.prune }}>{item.product.categorie}</span>
                    <h3 style={{ fontFamily: 'Georgia, serif', fontWeight: 400, fontSize: 17, color: C.pruneD, margin: '4px 0 8px', lineHeight: 1.3 }}>{item.product.nom}</h3>
                    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 12 }}>
                      <span style={{ background: C.cremeD, color: C.gris, fontSize: 11, padding: '2px 10px', borderRadius: 20, fontFamily: 'monospace' }}>Taille: {item.taille}</span>
                      {item.couleur && <span style={{ background: C.cremeD, color: C.gris, fontSize: 11, padding: '2px 10px', borderRadius: 20, fontFamily: 'monospace' }}>Couleur: {item.couleur}</span>}
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12 }}>
                      {/* Quantité */}
                      <div style={{ display: 'flex', alignItems: 'center', gap: 0, border: `1px solid ${C.cremeMid}`, borderRadius: 8, overflow: 'hidden' }}>
                        <button onClick={() => updateQty(item.key, item.quantite - 1)} style={{ width: 36, height: 36, border: 'none', background: C.cremeD, cursor: 'pointer', fontSize: 16, color: C.gris }}>−</button>
                        <span style={{ width: 40, textAlign: 'center', fontSize: 14, fontWeight: 600, color: C.pruneD, fontFamily: 'monospace' }}>{item.quantite}</span>
                        <button onClick={() => updateQty(item.key, item.quantite + 1)} style={{ width: 36, height: 36, border: 'none', background: C.cremeD, cursor: 'pointer', fontSize: 16, color: C.gris }}>+</button>
                      </div>
                      <span style={{ fontFamily: 'monospace', fontSize: 16, fontWeight: 700, color: C.prune }}>{(prix * item.quantite).toLocaleString('fr-CI')} FCFA</span>
                      <button onClick={() => { removeItem(item.key); toast.success('Article retiré'); }} style={{ background: 'none', border: 'none', cursor: 'pointer', color: C.rouge, fontSize: 13, fontWeight: 500 }}>✕ Retirer</button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Récapitulatif */}
          <div style={{ position: 'sticky', top: 88 }}>
            <div style={{ background: 'white', borderRadius: 16, padding: 24, border: `1px solid ${C.cremeMid}` }}>
              <h2 style={{ fontFamily: 'Georgia, serif', fontWeight: 300, fontSize: 22, color: C.pruneD, marginBottom: 20 }}>Récapitulatif</h2>

              {/* Code promo */}
              <div style={{ marginBottom: 20 }}>
                <div style={{ display: 'flex', gap: 8 }}>
                  <input value={promoInput} onChange={e => setPromoInput(e.target.value.toUpperCase())} placeholder="Code promo"
                    style={{ flex: 1, padding: '10px 14px', border: `1.5px solid ${C.cremeD}`, borderRadius: 8, fontSize: 13, fontFamily: 'monospace', outline: 'none', color: C.noir, textTransform: 'uppercase', letterSpacing: '.08em' }} />
                  <button onClick={handlePromo} disabled={loadingPromo} style={{ padding: '10px 16px', background: C.cremeD, border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 13, fontWeight: 600, color: C.prune, whiteSpace: 'nowrap' }}>
                    {loadingPromo ? '...' : 'Appliquer'}
                  </button>
                </div>
                {codePromo && <p style={{ fontSize: 12, color: C.vert, marginTop: 6, fontFamily: 'monospace' }}>✓ Code {codePromo} appliqué</p>}
              </div>

              {/* Totaux */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: 10, paddingBottom: 16, borderBottom: `1px solid ${C.cremeD}` }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 14 }}>
                  <span style={{ color: C.grisM }}>Sous-total</span>
                  <span style={{ fontFamily: 'monospace', color: C.noir }}>{subtotal().toLocaleString('fr-CI')} FCFA</span>
                </div>
                {remise > 0 && (
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 14 }}>
                    <span style={{ color: C.vert }}>Réduction</span>
                    <span style={{ fontFamily: 'monospace', color: C.vert }}>−{remise.toLocaleString('fr-CI')} FCFA</span>
                  </div>
                )}
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13 }}>
                  <span style={{ color: C.grisM }}>Livraison</span>
                  <span style={{ color: C.grisM, fontFamily: 'monospace' }}>Calculée à l'étape suivante</span>
                </div>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', padding: '16px 0', fontSize: 18, fontWeight: 700 }}>
                <span style={{ color: C.pruneD }}>Total</span>
                <span style={{ fontFamily: 'monospace', color: C.prune }}>{total().toLocaleString('fr-CI')} FCFA</span>
              </div>

              <button onClick={handleCheckout} style={{ width: '100%', padding: '15px', background: `linear-gradient(135deg, ${C.prune}, ${C.pruneL})`, color: C.or, border: 'none', borderRadius: 10, fontSize: 16, fontWeight: 700, cursor: 'pointer', fontFamily: 'DM Sans, sans-serif', boxShadow: `0 4px 20px rgba(74,25,66,.3)`, marginBottom: 12 }}>
                Commander maintenant →
              </button>
              <a href="https://wa.me/225XXXXXXXX" target="_blank" rel="noreferrer" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, width: '100%', padding: '13px', background: '#25D366', color: 'white', border: 'none', borderRadius: 10, fontSize: 14, fontWeight: 600, cursor: 'pointer', textDecoration: 'none', boxSizing: 'border-box' }}>
                <span>💬</span> Commander via WhatsApp
              </a>

              <div style={{ marginTop: 16, display: 'flex', justifyContent: 'center', gap: 16 }}>
                {['📱 MTN Money','📱 Orange Money','💙 Wave CI'].map(p => (
                  <span key={p} style={{ fontSize: 10, color: C.grisM, fontFamily: 'monospace' }}>{p}</span>
                ))}
              </div>
            </div>

            <Link to="/boutique" style={{ display: 'block', textAlign: 'center', marginTop: 16, fontSize: 14, color: C.grisM, textDecoration: 'none' }}>← Continuer les achats</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
